import React, { useState } from 'react';
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import './TitleDivSeo.css';

export default function HeadLines(props) {
  const [open, setOpen] = useState(false);
  const [showAllRows, setShowAllRows] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleShowMore = () => {
    setShowAllRows(true);
  };

  const handleShowLess = () => {
    setShowAllRows(false);
  };

  const renderTableRows = () => {
    const rowsToDisplay = showAllRows ? Object.entries(props.headlines) : Object.entries(props.headlines).slice(0, 1);

    return rowsToDisplay.map(([tag, texts]) => (
      <React.Fragment key={tag}>
        {texts.map((text, index) => (
          <tr style={{ border: "1px solid gray" }} key={index}>
            <td style={{ border: "1px solid gray" }}>{tag}</td>
            <td style={{ border: "1px solid gray" }}>{text}</td>
          </tr>
        ))}
      </React.Fragment>
    ));
  };

  const renderCountTableRows = () => {
    const headingCounts = {
      h1: 0,
      h2: 0,
      h3: 0,
      h4: 0,
      h5: 0,
      h6: 0,
    };

    Object.entries(props.headlines).forEach(([tag, texts]) => {
      const headingLevel = tag.toLowerCase();
      if (headingCounts.hasOwnProperty(headingLevel)) {
        headingCounts[headingLevel] += texts.length;
      }
    });

    const headingLevels = Object.keys(headingCounts);
    const counts = Object.values(headingCounts);

    const headerRow = headingLevels.map((level, index) => (
      <th style={{ border: "1px solid gray" }} key={index}>{level}</th>
    ));

    const countRow = counts.map((count, index) => (
      <td style={{ border: "1px solid gray" }} key={index}>{count}</td>
    ));

    return (
      <>
        <tr style={{ border: "1px solid gray" }}>{headerRow}</tr>
        <tr style={{ border: "1px solid gray" }}>{countRow}</tr>
      </>
    );
  };

  const allRows = renderTableRows();

  return (
    <div>
      <div
        style={{ marginTop: '10px' }}
        className="TitleDivSeo"
      >
        <div className="CARD">
          <div
            style={{
              background: 'linear-gradient(to right, #ffcc00, #ff9900)',
              padding: '10px',
              borderRadius: "5px",
              opacity: "0.6",
              color: "white"
            }}
          >
            <h3>العناوين الرئيسية</h3>
          </div>
          <Card
            sx={{
              display: 'flex',
              justifyContent: 'center',
              padding: '10px',
              textAlign: 'center',
            }}
          >
            <div style={{ width: '100%' }}>
              <Typography variant="subtitle1" color="text.secondary" component="div">
                <div style={{ width: '100%', display: "flex", justifyContent: "space-between" }}>
                  <table style={{ width: '90%' }}>
                    <tbody>{renderCountTableRows()}</tbody>
                  </table>
                  {props.headingAnalysis === "good" ? (
                    <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} />
                  ) : props.headingAnalysis === "to be improved" ? (
                    <PriorityHighIcon style={{ color: "#f39c12", fontSize: "50px" }} />
                  ) : props.headingAnalysis === "bad" ? (
                    <ClearIcon style={{ color: "red", fontSize: "50px" }} />
                  ) : <ClearIcon style={{ color: "red", fontSize: "50px" }} />}
                </div>

                <div style={{ width: '100%' }}>
                  {props.headingAnalysis === "no headings" ? <h3
                    style={{
                      color: 'rgb(78, 181, 76)',
                      textAlign: "right", marginTop: "15px"
                    }}>لايوجد عناوين وصفية لموقعك😯</h3>
                    :
                    <>
                      <h2 style={{ color: 'rgb(78, 181, 76)' }}>العناوين الرئيسية</h2>
                      <table style={{ width: '90%' }} border="1">
                        <thead style={{ border: "1px solid gray" }}>
                          <tr style={{ border: "1px solid gray" }}>
                            <th style={{ border: "1px solid gray" }}>Tag</th>
                            <th style={{ border: "1px solid gray" }}>Text</th>
                          </tr>
                        </thead>
                        <tbody style={{ border: "1px solid gray" }}>{allRows}</tbody>
                      </table>
                      {Object.entries(props.headlines).length > 3 && (
                        <div>
                          {showAllRows ? (
                            <Button onClick={handleShowLess}>Show Less</Button>
                          ) : (
                            <Button onClick={handleShowMore}>Show More</Button>
                          )}
                        </div>
                      )}
                    </>
                  }

                </div>

              </Typography>
            </div>
          </Card>
        </div>
        {/* <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent style={{ direction: 'rtl' }}>
            <DialogContentText
              id="alert-dialog-description"
              style={{ color: 'rgb(78, 181, 76)' }}
            >
              العناوين، من H1 إلى H6، هي عناصر أساسية في محتوى المواقع الإلكترونية توفر هيكلًا تسلسليًا لصفحاتك. تعتمد محركات البحث على هذه العناوين لفهم تنظيم وجدوى المحتوى. يُظهر الاستخدام السليم لعلامات H1 الموضوع الرئيسي للصفحة، مما يوجه محركات البحث في تصنيف وفهرسة محتواك بدقة. تقسم المستويات اللاحقة للعناوين، مثل H2 إلى H6، المحتوى إلى أقسام فرعية، مساعدة كل من محركات البحث والمستخدمين في فهم تدفق المعلومات. العناوين المنظمة بشكل جيد لا تعزز فقط تحسين محركات البحث من خلال جعل محتواك أكثر إمكانية الوصول لزوار محركات البحث، ولكنها تعزز أيضًا تجربة المستخدم العامة عبر جعل المحتوى أكثر قراءة ومسحًا. بالإضافة إلى ذلك، يمكن أن تعزز وضع استراتيجي للكلمات الرئيسية داخل العناوين الاستفادة من محتواك لتعزيز القابلية للبحث لاستفسارات معينة، مما يحسن أداء موقعك على نتائج محركات البحث.
            </DialogContentText>
          </DialogContent>
          <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>
            close
          </Button>
        </Dialog> */}
      </div>
    </div>
  );
}




